export default __webpack_public_path__ + "static/media/search.ef458162.svg";